var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.91,
    height: 18.912,
    viewBox: "0 0 18.91 18.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CROIX",
    transform: "translate(-421.555 -282.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_631",
    "data-name": "Trac\\xE9 631",
    d: "M438.893,301.655a1.514,1.514,0,0,1-1.077-.447L422,285.334a1.519,1.519,0,0,1,2.152-2.143l15.82,15.875a1.519,1.519,0,0,1-1.077,2.591Z",
    transform: "translate(0)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_632",
    "data-name": "Trac\\xE9 632",
    d: "M423.074,301.644A1.519,1.519,0,0,1,422,299.05l15.872-15.819a1.519,1.519,0,0,1,2.146,2.151L424.146,301.2A1.51,1.51,0,0,1,423.074,301.644Z",
    transform: "translate(0 0.01)",
    fill: "#181a3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.835cf45351d10f47027fd10891477ca9.svg";
export { ForwardRef as ReactComponent };